import { useUser } from "../../../hooks/react-query/useUser";
import { useRedirectAnonymous } from "../../../hooks/auth/useRedirectAnonymous";
import { Container } from "../../../components/UI/container/Container";
import { MyH1 } from "../../../components/UI/my-h1/MyH1";
import { AttachmentTabs } from "../../../components/pages/user/attachments/AttachmentTabs";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { Fragment } from "react";
import { MyHead } from "../../../components/pages/MyHead";
import { BackToProfile } from "../../../components/pages/user/BackToProfile";
import { Footer } from "../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function UserDocumentPage() {
  const redirect = useRedirectAnonymous();
  const { user } = useUser();
  const { t } = useTranslation("common");

  return (
    <Fragment>
      <MyHead
        title={t("user.medicalDocs")}
        description={t("user.medicalDocs")}
      />
      <BackToProfile />
      <MyH1 centerText className="pt-8 text-4xl">
        {t("user.medicalDocs")}
      </MyH1>
      {user && (
        <Container noHeight>
          <AttachmentTabs />
        </Container>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default UserDocumentPage;
